<script setup>
import { provide } from 'vue'

const props = defineProps({
  level: { type: Number, required: true },
})

provide('currentPanelLevel', props.level)
</script>

<template>
  <slot />
</template>
